import React from 'react';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownIcon from '@mui/icons-material/ArrowDownward';

const MoveArrow = ({handleClick, action}) => {
  const label = action === "up" ? "move up" : "move down";
  return (
    <Tooltip title={label}>
    <IconButton aria-label={label} onClick={handleClick}>
       {action === "up" ? <ArrowUpwardIcon /> : <ArrowDownIcon />}
    </IconButton>
  </Tooltip>
  );
}

export default MoveArrow;